<app-modal size="sm" dialogRole="alertdialog" [describedBy]="describedBy">
  <div class="if-modal-title">
    <h2 class="if-modal-title-heading">{{ options.title }}</h2>
    @if (options.subject) {
      <p class="if-modal-title-subheading" appTitleIfTruncated>{{ options.subject }}</p>
    }
  </div>
  <div class="if-modal-content">
    @if (options.question) {
      <p class="if-modal-question" [id]="questionId">{{ options.question }}</p>
    }
    @if (options.message) {
      <p class="if-modal-message" [id]="messageId">{{ options.message }}</p>
    }
    @if (options.acknowledge) {
      <app-checkbox
        class="confirm-acknowledge"
        size="sm"
        [label]="options.acknowledge"
        [disabled]="busy()"
        [ngModel]="acknowledged()"
        (ngModelChange)="acknowledged.set($event)" />
    }
    @if (options.action) {
      <p class="confirm-error" role="alert">{{ error() }}</p>
    }
  </div>
  <div class="if-modal-actions">
    <app-button variant="ghost" [attr.data-autofocus]="danger ? '' : null" [disabled]="busy()" (click)="cancel()">{{ cancelLabel }}</app-button>
    @if (options.secondaryLabel) {
      <app-button variant="outline" [disabled]="busy()" (click)="secondary()">{{ options.secondaryLabel }}</app-button>
    }
    <app-button
      class="confirm-primary"
      [variant]="danger ? 'error' : undefined"
      [attr.data-autofocus]="danger ? null : ''"
      [disabled]="!!options.acknowledge && !acknowledged()"
      [busy]="busy()"
      (click)="confirm()">{{ options.confirmLabel }}</app-button>
  </div>
</app-modal>
